import React from "react";
import { useTranslation } from "react-i18next";

// Compact REAL / TEST / DEMO / ALL filter chips (view-only, no data mutation).
// `options` limits which chips render (e.g. sections without a TEST concept).
export const ScopeChips = ({ value, onChange, options = ["REAL", "TEST", "DEMO", "ALL"], testid = "scope-filter" }) => {
  const { t } = useTranslation();
  const label = (o) => t(`admin.scope.${o.toLowerCase()}`);
  return (
    <div className="flex flex-wrap items-center gap-1 rounded-full border border-border p-1 text-xs" data-testid={testid}>
      {options.map((o) => (
        <button
          key={o}
          type="button"
          onClick={() => onChange(o)}
          data-testid={`${testid}-${o.toLowerCase()}`}
          aria-pressed={value === o}
          className={`rounded-full px-3 py-1 font-semibold uppercase tracking-wide transition-colors ${
            value === o ? "bg-brand text-white" : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {label(o)}
        </button>
      ))}
    </div>
  );
};

// Shared classifier for records that only carry an `isDemo` flag (users, cases):
// DEMO when isDemo, otherwise REAL. Returns true if the record matches `scope`.
export const matchesScope = (recordClass, scope) => scope === "ALL" || recordClass === scope;
export const isDemoClass = (rec) => (rec?.isDemo ? "DEMO" : "REAL");
